import React from 'react'
import { ProductWithActiveColour } from '../../types'
import { useFilters } from '../../context'
import { formatPrice } from '../../utils'

interface Props {
  product: ProductWithActiveColour
}

export const ProductPrice: React.FC<Props> = ({ product }) => {
  const { activeFilters } = useFilters()

  const activeColour = product.activeColour

  const from =
    activeFilters.colour.size === 1 || product.clearance ? undefined : 'from'

  if (!activeColour) return null

  if (activeColour.sale_price) {
    return (
      <p className="productblock-price __sale">
        {from && <em className="productblock-pricefrom">{from}</em>}£
        {formatPrice(activeColour.sale_price)}
        <span className="productblock-rrp">
          £{formatPrice(activeColour.price)}
        </span>
      </p>
    )
  }

  return (
    <p className="productblock-price">
      <em className="productblock-pricefrom">{from}</em> £
      {formatPrice(activeColour.price)}
    </p>
  )
}
